
// export const ipfs_uploader_api = 'https://5qay1k2tmaxmqf-5000.proxy.runpod.net/ipfs_uploader';
export const ipfs_uploader_api = 'https://hub.orbofi.com/ipfs-api/ipfs_uploader';


export const ORBOFI_BASE_IPFS_URL = 'https://orbofi.mypinata.cloud';
